export enum AddressSearchSource {
	Smarty = 'smarty',
	Supplier = 'supplier',
}

export interface AddressSuggestionData {
	address1: string;
	address2?: string;
	city?: string;
	stateId?: string;
	stateShort?: string;
	zipCode?: string;
	source: AddressSearchSource;
	rank?: number;
	unitCount?: number;
	expandSelection?: string;
}

export class AddressSuggestion {
	public address1: string;
	public address2: string;
	public city: string;
	public stateId: string;
	public stateShort: string;
	public zipCode: string;
	public source: AddressSearchSource;
	public rank: number;
	public unitCount: number;
	public expandSelection: string;

	constructor(row: AddressSuggestionData) {
		Object.assign(this, {
			address2: '',
			city: '',
			stateId: '',
			stateShort: '',
			zipCode: '',
			rank: 0,
			unitCount: 1,
			expandSelection: '',
			...row,
		});
	}

	public static formatLabel(address1: string, address2: string, city: string, stateShort: string, zipCode: string): string {
		if (!address1) {
			return '';
		}
		return [address1, address2, city, [stateShort, zipCode].filter(Boolean).join(' ')].filter(Boolean).join(', ');
	}

	// a building with several units; choosing it searches again for its units instead of filling the address
	get needsExpansion(): boolean {
		return !!this.expandSelection;
	}

	get typeaheadLabel(): string {
		const address2 = this.needsExpansion ? `${this.address2} (${this.unitCount} units)`.trim() : this.address2;
		return AddressSuggestion.formatLabel(this.address1, address2, this.city, this.stateShort, this.zipCode);
	}
}
